function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.016.531l10.406 10.547-135 134.438L.437 135.39 135.017.53zm0 39.797l10.406 10.547-95.203 94.64-9.985-10.124 94.782-95.063zM95.359.531l10.266 10.547-95.203 94.64L.437 95.595 95.36.53z"
});

var SvgLogo = function SvgLogo(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 146 146"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDYiIGhlaWdodD0iMTQ2IiB2aWV3Qm94PSIwIDAgMTQ2IDE0NiI+CiAgPHBhdGggZD0iTTMwNy4wMTU2MjUsMTc3LjUzMTI1IEwzMTcuNDIxODc1LDE4OC4wNzgxMjUgTDE4Mi40MjE4NzUsMzIyLjUxNTYyNSBMMTcyLjQzNzUsMzEyLjM5MDYyNSBMMzA3LjAxNTYyNSwxNzcuNTMxMjUgWiBNMzA3LjAxNTYyNSwyMTcuMzI4MTI1IEwzMTcuNDIxODc1LDIyNy44NzUgTDIyMi4yMTg3NSwzMjIuNTE1NjI1IEwyMTIuMjM0Mzc1LDMxMi4zOTA2MjUgTDMwNy4wMTU2MjUsMjE3LjMyODEyNSBaIE0yNjcuMzU5Mzc1LDE3Ny41MzEyNSBMMjc3LjYyNSwxODguMDc4MTI1IEwxODIuNDIxODc1LDI4Mi43MTg3NSBMMTcyLjQzNzUsMjcyLjU5Mzc1IEwyNjcuMzU5Mzc1LDE3Ny41MzEyNSBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcyIC0xNzcpIi8+Cjwvc3ZnPgo=";
export { SvgLogo as ReactComponent };